import React from 'react';

interface SidebarContextProps {
  collapsed: boolean;
  setCollapsed: () => void;
}

const SidebarContext = React.createContext<SidebarContextProps>({
  collapsed: false,
  setCollapsed: () => {},
});

export const useSidebarContext = () => {
  const context = React.useContext(SidebarContext);
  if (!context) {
    throw new Error('useSidebarContext must be used within SidebarContext');
  }
  return context;
};

export { SidebarContext };